import React, { FC, ReactNode } from "react";

import "./style.css";


export interface RibbonProperties {
    side: "left" | "right",
    label: ReactNode,
}

const Ribbon: FC<RibbonProperties> = ({
    label,
    side = "right",
}) => {
    return <><div className={`ribbon ribbon-top-${side}`}><span>{label}</span></div></>
}

export { Ribbon }